import * as React from 'react';
export const IcFootball = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12 2a10 10 0 100 20 10 10 0 000-20zM5.21 9.78l-1.06.66a8 8 0 01.63-1.86l.43 1.2zm1.36 1.52l1.43.42.93 2.86-.84 1.2-3 .1a7.93 7.93 0 01-1-3l2.48-1.58zm1.24 6.49L8.1 19a8.379 8.379 0 01-1.56-1.15l1.27-.06zm8.42 0l1.17.08A7.6 7.6 0 0115.88 19l.35-1.21zm-.2-2l-.91-1.23.93-2.84 1.39-.45 2.5 1.7a8.1 8.1 0 01-1 3l-2.91-.18zm2.8-6l.45-1.09c.261.568.453 1.166.57 1.78l-1.02-.69zM18 6.67l-1.1 2.68-1.49.48L13 8.12V6.61l2.39-1.85A8.14 8.14 0 0118 6.67zm-5-2.6l-1 .77-.93-.79c.309-.033.62-.05.93-.05a8.42 8.42 0 011 .07zm-4.25.63L11 6.59v1.53L8.63 9.84 7.2 9.4l-1-2.86A8 8 0 018.75 4.7zm1.62 15.13L9.67 17l.83-1.2h3l.86 1.17-.85 2.91a8 8 0 01-3.18 0l.04-.05z'
      fill='currentColor'
    />
  </svg>
);
